import GroupsIcon from '@mui/icons-material/Groups';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { Box, Card, CardActionArea, CardContent, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

interface HubOption {
  to: string;
  title: string;
  description: string;
  icon: React.ReactNode;
}

const OPTIONS: HubOption[] = [
  {
    to: '/admin/disagreements/consensus-vs-ai',
    title: 'Label consensus vs AI',
    description:
      'Entities where the human-labeller consensus disagrees with the AI judgement, at each criterion’s sentence, paragraph, or essay granularity. Adjudicate to record ground-truth corrections.',
    icon: <SmartToyIcon fontSize="large" />,
  },
  {
    to: '/admin/disagreements/consensus-vs-human',
    title: 'Label consensus vs human',
    description:
      "Entities where a selected labeller's judgements disagree with the ground-truth consensus from the rest of the team, at each criterion’s granularity. Useful for calibrating trainees and spot-checking labellers.",
    icon: <GroupsIcon fontSize="large" />,
  },
];

const ResolveDisagreementsHub: React.FC = () => {
  return (
    <Box sx={{ mt: 4, px: 3 }}>
      <Typography variant="h4" sx={{ mb: 1 }}>
        Resolve Disagreements
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Pick a disagreement source to review.
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gap: 2,
          gridTemplateColumns: { xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' },
          maxWidth: 900,
        }}
      >
        {OPTIONS.map(option => (
          <Card key={option.to} variant="outlined">
            <CardActionArea component={Link} to={option.to} sx={{ height: '100%' }}>
              <CardContent sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', p: 3 }}>
                <Box sx={{ color: 'primary.main', mt: 0.5 }}>{option.icon}</Box>
                <Box>
                  <Typography variant="h6" sx={{ mb: 0.5 }}>
                    {option.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {option.description}
                  </Typography>
                </Box>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default ResolveDisagreementsHub;
